import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";

const IndexPage = () => (
  <Layout>
    <SEO title="Damian Wilk - About" />
    <section style={{ marginBottom: "64px" }}>
      <div className="container">
        <div className="mb-2">
          <h3 className="span mb-1 text-center">About me</h3>
          <p>
            I mainly work with HTML5 and CSS 3. I mostly write SCSS code which I
            compile to minified CSS files. When interactivity is required I use
            plain JavaScript or React which allows me to divide my application
            into components and “react” to changes in the UI.
          </p>{" "}
          <br />
          <p>
            I am both a passionate linguist and developer. Besides building
            websites, web apps and translating projects, I learn about new
            technologies on a daily basis. Currently I explore the potential of
            PWAs which allow us to turn websites into mobile applications that
            can even work offline.
          </p>
        </div>
        <div className="mb-2">
          <h3 className="span mb-1 text-center">Favourite books</h3>
          <p>
            <span className="book-title">
              How To Win Friends And Influence People
            </span>{" "}
            by Dale Carnegie - a timeless book that everyone should read.
          </p>
          <br />
          <p>
            <span className="book-title">Unscripted</span> by MJ DeMarco - an
            eye opening book on life and business. Some may find it
            controversial, but it’s definitely a mind blowing book that’s worth
            reading.
          </p>
        </div>
        <div className="mb-2">
          <h3 className="span mb-1 text-center">Favourite games</h3>
          <p>
            I sometimes like to build a new level in{" "}
            <span className="book-title">Super Mario Maker 2</span>. I also
            follow the news about <span className="book-title">Overwatch</span>.
          </p>
        </div>
        {/* <div className="mb-2">
          <h3 className="span mb-1 text-center">Resume</h3>
        </div> */}
      </div>
    </section>
  </Layout>
);

export default IndexPage;
